import shopDetailOtherDish from './oherDish'
import shopDetailOtherEmail from './oherEmail'
import shopDetailOtherBankflow from './oherBankflow'
import shopDetailOtherExtra from './oherExtra'
import shopDetailOtherIsIllegal from './otherIsIllegal'  // 商户官网
import shopDetailOtherOfficialUrl from './otherOfficialUrl'  // 是否违规
import baseDetail from './baseDetail'

export default {
  shopDetailOtherDish,
  shopDetailOtherEmail,
  shopDetailOtherBankflow,
  shopDetailOtherExtra,
  shopDetailOtherIsIllegal,
  shopDetailOtherOfficialUrl,
  baseDetail                // 基础信息
}
